var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyRefer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.925,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.782 2.699L10.2.124A.431.431 0 009.9 0H3.606a.324.324 0 00-.285.306v3.268H.286A.328.328 0 000 3.88v11.814A.33.33 0 00.306 16h8.983a.332.332 0 00.316-.316v-3.259h3a.331.331 0 00.316-.315V2.963a.386.386 0 00-.139-.264zm-.927-.063zM8.983 15.378H.631V4.196H6.3v2.342a.331.331 0 00.316.315h2.369zM6.925 6.213V4.63l1.609 1.58z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/copy_refer.52e9e3d08e636c614d32f0102975bc76.svg";
export { SvgCopyRefer as ReactComponent };